import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

const withRouter = WrappedComponent => props => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <WrappedComponent {...props} navigate={navigate} params={params} dispatch={dispatch} />
    );
};

export default withRouter;